import { css } from 'emotion';

const selectAuthorisorStyles = css`
	flex-wrap: wrap;
	justify-content: center;
	.c-a-button {
		margin-top: 1.5rem;
		order: 3;
	}
	@media (min-width: 600px) {
		.c-a-button {
			margin-top: 0.5rem;
		}
	}
`;

const authorisationPanelStyles = css`
	flex-wrap: wrap;
	justify-content: center;

	.c-m-payment-review__status-value {
		margin-bottom: 1rem;
	}

	.c-m-payment-review__status-label {
		svg {
			fill: hsl(217, 33%, 38%) !important;
		}
	}

	@media (min-width: 1280px) {
		justify-content: center;
		.c-m-payment-review__status-label {
			flex-basis: 100%;
			justify-content: center;
			margin-bottom: 0.5rem;
			order: 0;
			padding: 0;
		}
		.c-m-payment-review__status-value {
			text-align: center;
		}
	}

	button {
		text-align: center;
	}
`;

const paymentReviewStatusStyles = css`
	@media (min-width: 600px) and (max-width: 1280px) {
		max-width: 300px;
	}
`;

const paymentReviewIconStyles = css`
	svg {
		fill: hsl(217, 33%, 38%) !important;
	}
`;

export { selectAuthorisorStyles, authorisationPanelStyles, paymentReviewStatusStyles, paymentReviewIconStyles };
